import React from 'react';
import classes from './Toolbar.css';
import Logo from '../../Logo/Logo';
import NavItems from '../NavItems/NavItems';
import DrawerToggle from '../SideDrawer/DrawerToggle/DrawerToggle';

const toolbar = props => (

	<header className={ classes.Toolbar }>
		<DrawerToggle clicked={ props.drawerToggleClicked }/>
		<div className={ classes.Logo }>
			<Logo/>
		</div>
		<nav className={ classes.DesktopOnly }>
			<NavItems isAuthenticated={ props.isAuth }/>
		</nav>
	</header>

);

export default toolbar;


// WEBPACK FOOTER //
// ./src/components/Navigation/Toolbar/Toolbar.js